import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/wall/u7-pro-xg-wall.png";
import type { Product } from "../../types";
import {
  connectedDevices,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";
import { customization } from "../properties/customization";
import { wifiWall } from "../product-list-groups/wifiWall";

export const u7proXgWall: Product = {
  id: "u7proXgWall",
  productTitle: "U7 Pro XG Wall",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u7-pro-xg-wall`,
  ],
  storePathParts: {
    productSlug: "u7-pro-xg-wall",
    category: UniFiChildCategorySlug.WiFiWall,
  },
  isNew: true,
  description: "u7proXgWall.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7proWall.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "string",
        value: "155 x 108 x 33.5 mm\n(6.1 x 4.3 x 1.3'')",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u7proXgWall.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u7proXgWall.mounting",
        asterisk: 1,
      },
    },
    {
      propertyId: customization.id,
      value: {
        type: "translation",
        value: "u7proXgWall.customization",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u7proXgWall.notes"],
};
